var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"person"},[_c('navbar',{attrs:{"isHiddenlogin":false}}),_c('div',{staticClass:"person-page"},[_c('Sidebar'),_c('div',{staticClass:"person-content"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }